import { REACT_APP_BASE_URL, REACT_APP_OKTA_CLIENT_ID } from './app.js';

export const AuthConfig = {
  Okta: {
    issuer: 'https://auth.weaveconnect.com/oauth2/default',
    clientId: REACT_APP_OKTA_CLIENT_ID,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'email', 'profile'],
  },
  Google: {
    domain: 'getweave.auth0.com',
    clientID: 'qaxIDSGsXuBypfF8d1qsFhMVQY0ZdCHQ',
    redirectUri: REACT_APP_BASE_URL,
    responseType: 'token id_token',
    scope: 'openid profile email',
  },
};
